import React from 'react';
import { FlatDomainDataContext, FormBean, IUIViewDef } from '../../datatypes';
import renderChildUIComponents from './metadata-mapper';
import {v4 as uuidv4} from 'uuid';

interface ViewProps {
    metadata:IUIViewDef;
    formBean:FormBean;
    ctx:FlatDomainDataContext;
}

export default class View extends React.Component<ViewProps,{}> {
  constructor(props:ViewProps){
      super(props);
  }

  render() {
    const callId = uuidv4();

    const {metadata} = this.props;
    const {cssClasses} = metadata;
    let className = "baseView " + (cssClasses ? cssClasses : '');
    console.debug(`View render ${callId} START. componentId=${metadata.componentId}`);

    const result = (
      <div className={className}>
        {renderChildUIComponents(this.props)}
      </div>
    )
    console.debug(`View render ${callId} END. componentId=${metadata.componentId}`);

    return result;
  }
}